module.exports = __webpack_public_path__ + "img/home-bg6-2.f98f98a6.png";